import React, { useContext, useEffect, useState } from "react";
import {
  Paper,
  makeStyles,
  Button,
  Box,
  Table,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  TableContainer,
  TextField,
  InputAdornment,
  useTheme,
} from "@material-ui/core";
import { alpha } from "@material-ui/core/styles/colorManipulator";
import AddIcon from "@material-ui/icons/Add";
import { Pagination } from "@material-ui/lab";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import SearchIcon from "@material-ui/icons/Search";
import AlertDialog from "../../components/Alert/AlertDialog";
import CreateSpeciality from "./CreateSpeciality";
import { useDispatch, useSelector } from "react-redux";
import { deleteSpecialities, getSpecialities } from "../../store/action";
import UpdateSpeciality from "./UpdateSpeciality";
import Notification from "../../components/Notification/Notification";
import EnhancedTableHead from "./EnhancedTableHead";
import { headCells } from "./Headcells";
import TablePaginationControls from "../../components/TablePaginationControls";
import Loading from "../../components/Loading/Loading";
import moment from "moment/moment";
import { ThemeContext } from "../../App";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: 20,
    background: theme.palette.background.main

  },
  container: {
    marginTop: "15px",
    maxHeight: "calc(100vh - 260px)",
    overflow: "auto"
  },
}));

const Specialities = () => {
  const theme = useTheme();
  const classes = useStyle();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [openUpdate, setOpenUpdate] = useState(false);
  const [Id, setId] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deleteNotify, SetDeleteNotify] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const staffDetail = JSON.parse(localStorage.getItem("staffDetail"));

  const [page, setPage] = React.useState(1);
  const [perPage, setPerPage] = useState(10);
  const [searchData, setSearchData] = useState({ search: "", status: "" });
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("speciality_name");
  const { getSpecialityItem, loading, deleteSuccess, deleteError } =
    useSelector((state) => state.specialities);
  const loginUserInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
  const { mode } = useContext(ThemeContext);
  const handleClickOpen = (id) => {
    setOpen(true);
  };
  const handleUpdateClickOpen = (id) => {
    setOpenUpdate(true);
    setId(id);
  };

  const handleClose = () => {
    setOpen(false);
    setOpenUpdate(false);
  };

  const deleteSpeciality = () => {
    setDeleteOpen(true);
  };
  const deleteRoleClose = () => {
    setDeleteOpen(false);
  };

  const alertResponse = (id) => {
    if (disabled === true) {
      dispatch(deleteSpecialities(id));
    }
    setDisabled(false);
    SetDeleteNotify(true);
  };

  // -----------------------------------
  const handleSearchChange = (event) => {
    const d1 = event.target.value;
    if (d1) {
      setTimeout(getSpecialitiesData(page, perPage, d1), 100);
    } else {
      setTimeout(getSpecialitiesData(page, perPage, ""), 100);
    }
    setSearchData({ ...searchData, [event.target.name]: event.target.value });
  };

  const handleClickSearch = (event, value) => {
    setTimeout(getSpecialitiesData(1, perPage, searchData.search), 1000);
  };

  const handleChangePage = (event, value) => {
    setPage(value);
    setTimeout(getSpecialitiesData(value, perPage, searchData.search), 2000);
  };

  const handlePerPageChange = (event) => {
    const newPerPage = parseInt(event.target.value, 10);
    setPerPage(newPerPage);
    setPage(1);
    getSpecialitiesData(1, newPerPage, searchData.search);
  };

  const getSpecialitiesData = (
    pageNo = 1,
    perPage = 15,
    search = "",
    type = order,
    column_name = orderBy
  ) => {
    dispatch(getSpecialities({ pageNo, perPage, search, type, column_name }));
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    getSpecialitiesData(page, perPage, searchData.search, isAsc ? "desc" : "asc", property);
  };

  useEffect(() => {
    getSpecialitiesData(page, perPage, searchData.search);
  }, [order, orderBy]);

  const deleteSpecialitiesData = (id) => {
    setId(id);
    setDeleteOpen(true);
    setDisabled(true);
    // dispatch(deleteSpecialities(id))
  };
  useEffect(() => {
    document.documentElement.style.setProperty('--bg-color', theme.palette.grey[1000]);
    document.documentElement.style.setProperty('--sticky-header', theme.palette.thead);
    document.documentElement.style.setProperty('--sticky-odd', theme.palette.background.stickyOdd);
    document.documentElement.style.setProperty('--sticky-even', theme.palette.background.stickyEven);
  }, [mode]);
  return (
    <>
      {loading && <Loading open={loading} />}

      {deleteNotify && deleteSuccess?.message && (
        <Notification data={deleteSuccess?.message} status="success" />
      )}

      {deleteNotify && deleteError?.message && (
        <Notification data={deleteError?.message} status="error" />
      )}

      <Paper className={`${classes.root} mb-6`}>
        <Box display="flex" alignItems="center" justifyContent="space-between">

          <div className={classes.search}>
            <TextField
              size="small"
              placeholder="Search now..."
              name="search"
              variant="outlined"
              onChange={handleSearchChange}
              onKeyPress={(e) => e.key === "Enter" && handleClickSearch()}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon
                      style={{
                        color: "#856f6f", // Icon color
                        cursor: "pointer",
                      }}
                      onClick={handleClickSearch}
                    />
                  </InputAdornment>
                ),
              }}
              className="modernSearchField"
            />
          </div>
          {staffDetail !== "Booking" && staffDetail !== "Finance" && ((loginUserInfo?.role === "STAFF" &&
            loginUserInfo?.permissions?.some(p => p.toLowerCase() === "specialities-create")) || (loginUserInfo?.role !== "STAFF")) && (
              <div className="ml-5">
                <Button
                  variant="contained"
                  style={{ textTransform: "capitalize" }}
                  color="primary"
                  onClick={handleClickOpen}
                >
                  <AddIcon className="mr-2" />
                  Add Speciality
                </Button>
              </div>
            )}
        </Box>

        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table">
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={(event, property) => {
                handleRequestSort(
                  property,
                  setOrder,
                  setOrderBy,
                  orderBy,
                  order
                );
              }}
              rowCount={getSpecialityItem?.data?.data?.length}
              headCells={headCells[0]}
            />
            <TableBody>
              {getSpecialityItem?.data &&
                getSpecialityItem?.data.map((row, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                        {getSpecialityItem?.from + index}
                      </TableCell>
                      <TableCell align="left" style={{ color: theme.palette.listItem }}>{row.speciality_name}</TableCell>
                      <TableCell align="left" style={{ color: theme.palette.listItem }}>{row.user_name ?? "-"}</TableCell>
                      <TableCell align="left" style={{ color: theme.palette.listItem }}>{moment(row.created_at).format("DD-MMM-YYYY")}</TableCell>

                      {staffDetail !== "Booking" &&
                        staffDetail !== "Finance" && (
                          <TableCell align="center" style={{ color: theme.palette.listItem }}>
                            <Box
                              display="flex"
                              alignItems="center"
                            // justifyContent="flex-end"
                            >
                              {((loginUserInfo?.role === "STAFF" &&
                                loginUserInfo?.permissions?.some(p => p.toLowerCase() === "specialities-update")) || (loginUserInfo?.role !== "STAFF")) && (<IconButton
                                  size="small" title="Edit"
                                  onClick={() => handleUpdateClickOpen(row.id)}
                                  style={{ padding: 6 }}
                                >
                                  {/* <EditIcon /> */}
                                  <EditIcon color="primary" />
                                </IconButton>)}
                              {((loginUserInfo?.role === "STAFF" &&
                                loginUserInfo?.permissions?.some(p => p.toLowerCase() === "specialities-delete")) || (loginUserInfo?.role !== "STAFF")) && (<IconButton
                                  size="small" title="Delete"
                                  onClick={() => deleteSpecialitiesData(row.id)}
                                  style={{ padding: 6 }}
                                >
                                  {/* <DeleteIcon /> */}
                                  <DeleteIcon color="secondary" />
                                </IconButton>)}
                            </Box>
                          </TableCell>
                        )}
                    </TableRow>
                  );
                })}
              {!getSpecialityItem?.data && (
                <TableRow>
                  <TableCell scope="row" colSpan="3">
                    <div className="" align="center">
                      Sorry, speciality not available!
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePaginationControls
          page={page}
          rowsPerPage={perPage}
          totalRecords={getSpecialityItem?.total}
          onPageChange={handleChangePage}
          handlePerPageChange={handlePerPageChange}
        />
      </Paper>

      <CreateSpeciality open={open} handleClose={handleClose} />

      <UpdateSpeciality open={openUpdate} handleClose={handleClose} id={Id} />

      <AlertDialog
        id={Id}
        open={deleteOpen}
        close={deleteRoleClose}
        response={alertResponse}
        title="Delete Speciality"
        description="Are you sure you want to delete?"
        buttonName="Delete"
      />

    </>
  );
};

export default Specialities;
